import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppInformationService, AuthService } from './core.module';
import { EntityManagerProvider } from './data/entity-manager-provider';

@Injectable({
    providedIn: 'root'
})
export class PrepareGuard {
    constructor(
        public entityManagerProvider: EntityManagerProvider, 
        private auth: AuthService, 
        private appInfo: AppInformationService
    ) {}

    async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (!this.auth.loggedIn) {
            return false;
        }

        try {
            this.appInfo.pleaseWaitShow();
            await this.entityManagerProvider.prepare();
            // await this.auth.getCurrentUser();
            this.appInfo.pleaseWaitHide();
            return true;
        } catch (e) {
            this.appInfo.pleaseWaitHide();
            // if (e.status == 401) {
            //     //this.authService.redirectUrl = state.url;
            //     this.router.navigate(['/login']);
            //     return false;
            // }
            console.error('Error connecting to data service: ' + EntityManagerProvider.serviceName, e);
            return false;
        }
    }
}
